<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-head">
      <h2>历史迁移</h2>
      <p>历史成交不重新计算；资料不完整的记录由管理员核对并留痕</p>
    </div>
    <el-card shadow="never">
      <el-form inline>
        <el-form-item label="状态">
          <el-select
            v-model="status"
            clearable
            @change="load"
          >
            <el-option
              label="待处理"
              value="PENDING"
            />
            <el-option
              label="已处理"
              value="COMPLETED"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <el-table
        :data="rows"
        v-loading="loading"
      >
        <el-table-column
          prop="legacy_transaction_id"
          label="原成交ID"
        />
        <el-table-column
          prop="customer_name"
          label="客户"
        />
        <el-table-column
          prop="housing_number"
          label="房源编号"
        />
        <el-table-column
          prop="tran_point"
          label="原成交地点"
        />
        <el-table-column
          prop="com_amount"
          label="原应收"
        />
        <el-table-column
          prop="issue"
          label="问题"
          min-width="220"
        />
        <el-table-column
          prop="status"
          label="状态"
        >
          <template #default="{ row }">
            <StatusTag :status="row.status" />
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template #default="{ row }">
            <el-button
              v-if="row.status !== 'COMPLETED'"
              link
              type="primary"
              @click="complete(row)"
            >
              标记完成
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-empty
        v-if="!loading && !rows.length"
        description="没有待处理的历史记录"
      />
    </el-card>
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { organizationApi } from '../api'
import StatusTag from '../components/StatusTag.vue'
const rows = ref([]),
  loading = ref(false),
  status = ref('PENDING')
const load = async () => {
  loading.value = true
  try {
    rows.value =
      (await organizationApi.migration({ status: status.value })) || []
  } finally {
    loading.value = false
  }
}
const complete = async (r) => {
  try {
    const { value } = await ElMessageBox.prompt(
      '请填写核对和处理说明',
      '完成迁移事项',
      { inputValidator: (v) => !!v?.trim() || '处理说明不能为空' }
    )
    await organizationApi.completeMigration(r.id, value)
    ElMessage.success('已完成')
    load()
  } catch (e) {
    if (e !== 'cancel') ElMessage.error(e?.message || '操作失败')
  }
}
onMounted(load)
</script>
<style scoped>
.page-head {
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
}
.page-head p {
  color: #8492a6;
  margin-top: 6px;
}
.el-card {
  border: 0;
}
</style>
